import { Button, CircularProgress } from "@mui/material";
import { AppColors } from "../../constants/AppColors";

type AppButtonProps = {
  title: string;
  onClick?: () => void;
  loading?: boolean;
  disabled?: boolean;
  variant?: "text" | "outlined" | "contained";
  color?: "primary" | "inherit" | "error";
  fullWidth?: boolean;
  type?: "button" | "submit";
};

const AppButton = ({
  title,
  onClick,
  loading,
  disabled,
  variant = "contained",
  color = "primary",
  fullWidth = true,
  type = "button",
}: AppButtonProps) => {
  return (
    <Button
      type={type}
      fullWidth={fullWidth}
      variant={variant}
      color={color}
      disabled={disabled || loading}
      onClick={onClick}
      sx={{
        minHeight: 48,
        bgcolor:
          variant === "contained" && color === "primary"
            ? AppColors.primary
            : undefined,
      }}
    >
      {loading ? <CircularProgress size={22} color="inherit" /> : title}
    </Button>
  );
};

export default AppButton;
